export default __webpack_public_path__ + "static/media/fv_banner_pc.b01aede4.jpg";